/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *
 * @file ResourceCardStyles.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */
import ResourceUtils from '../../utils/ResourceUtils';
import { THEME_DARK } from '../../common/constants';

const ResourceCardStyles = (theme) => ({
  arrow: {
    color: '#000000'
  },
  selectedSpan: {
    color: theme.color.activePrimary,
    paddingRight: 5
  },
  tooltip: {
    backgroundColor: '#000000'
  },
  resourceCardItem: {
    width: 150,
    height: 150,
    background: theme.activeTheme === THEME_DARK ? theme.color.toggle : theme.color.cardBackground,
    marginLeft: 20,
    border: '1px solid rgba(199, 199, 199, 0.4)',
    borderRadius: 8,
    padding: '5px 10px',
    '&:hover': {
      backgroundColor: theme.activeTheme === THEME_DARK ? theme.color.toggle : theme.color.cardBackground
    },
    '& > span': {
      height: '100%',
      display: 'block',
      '& .resource-card': {
        boxShadow: 'unset',
        backgroundColor: theme.activeTheme === THEME_DARK ? theme.color.toggle : theme.color.cardBackground,
        color: theme.color.textPrimary,
        '& .resource-card-item-heading': {
          height: 34,
          display: 'flex',
          alignItems: 'center',
          padding: 0,
          '& .resource-card-item-heading-name': {
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            fontFamily: 'Hind',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: 14,
            lineHeight: '120%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxHeight: 34,
            paddingLeft: 3,
            '&.item-disable': {
              color: '#6a7070'
            }
          },
          '& .resource-card-item-flex-grow': {
            flexGrow: 1
          },
          '& .resource-card-actions-downloadable': {
            padding: 0
          }
        },
        '& .resource-card-actions': {
          padding: 0,
          '& .resource-card-action-item': {
            display: 'flex',
            flexDirection: 'column',
            '& .resource-card-action-item-image': {
              marginTop: 4,
              marginBottom: 6,
              height: 70,
              width: 124,
              borderRadius: 8,
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).backgroundColor.yellowPrimary,
              color: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).color.yellowPrimary,
              '&.document, &.quiz': {
                background: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).backgroundColor.blueMedium,
                color: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).color.blueMedium
              },
              '&.video, &.image': {
                background: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).backgroundColor.purpleMedium,
                color: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).color.purpleMedium
              },
              '&.audio, &.zip': {
                background: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).backgroundColor.pinkPrimary,
                color: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).color.pinkPrimary
              },
              '&.weblink, &.sparklab': {
                background: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).backgroundColor.tealMedium,
                color: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).color.tealMedium
              },
              '&.picture, &.interactive': {
                background: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).backgroundColor.medGrey,
                color: ResourceUtils.getThumbnailColorPalette(theme.activeTheme).color.medGrey
              },
              '& .resource-card-action-item-image-circle': {
                height: 40,
                width: 40,
                background: theme.activeTheme === THEME_DARK ? theme.color.toggle : theme.color.cardBackground,
                borderRadius: '50%',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center'
              }
            },
            '& .resource-card-action-item-information': {
              display: 'flex',
              justifyContent: 'space-between',
              fontFamily: 'Hind',
              fontSize: 14,
              alignItems: 'center'
            }
          }
        }
      }
    }
  }
});

export default ResourceCardStyles;
